import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import Select from 'react-select';
import DesignationCustomRequisitionComponent from './DesignationCustomRequisitionComponent';
import getLocale from '../../../i18n/getLocale';

class DesignationCustomRequisitionTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      id: this.props.designation_id,
      name: null,
      designation_requisitions: [],
      type: null,
    };

    //bind específico
    this.addRequisition = this.addRequisition.bind(this);
    this.deleteRequisiton = this.deleteRequisiton.bind(this);

    // Handlers
    this.locale = getLocale();

  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  // LM
  componentWillReceiveProps(newProps) {
    this.setState({id: newProps.designation_id});
    if(Array.isArray(newProps.designation_requisitions)) {
      this.setState({designation_requisitions: newProps.designation_requisitions});
    }
  }

  addRequisition(event) {
    event.preventDefault();
    var datasave = {
      designation_id: this.state.id,
      name: this.state.name,
      type: this.state.type,
      hours_limit: this.state.hours_limit,
      days: this.state.days,
    };
    var self = this;
    self.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/designacao/requisicao/personalizada', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.props.loadData(responseJson);
        } else {
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  deleteRequisiton(id) {
    if(window.confirm(this.locale.Designacoes.EditarDesignacao.tabRequisitosPersonalizados.deletarRequisicaoDeHoras)) {
      var self = this;
      self.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/designacao/requisicao/personalizada/'+id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.props.loadData(responseJson);
          } else {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }


  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <form onSubmit={this.addRequisition}> 
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosPersonalizados.formulario.Nome}:</label>
          <input value={this.state.name} name="name" className="form-control" onChange={this.handleChange.bind(this, 'name')} placeholder={this.locale.Designacoes.EditarDesignacao.tabRequisitosPersonalizados.formulario.placeholder.NomeDoRequisito} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosPersonalizados.formulario.Tipo}:</label>
          <Select
            className="form-field-name"
            name="type"
            value={this.state.type}
            searchable={true}
            placeholder={this.locale.Designacoes.EditarDesignacao.tabRequisitosPersonalizados.formulario.placeholder.SelecionarTipo}
            onChange={this.handleSelectChange.bind(this, 'type')}
            options={[
                {value: "hours_total", label: this.locale.Designacoes.EditarDesignacao.tabRequisitosPersonalizados.formulario.opcoesTipo.LimiteDeHorasDeVoo},
                {value: "hours_journey", label: this.locale.Designacoes.EditarDesignacao.tabRequisitosPersonalizados.formulario.opcoesTipo.LimiteDeHorasDeJornada},
            ]}
          required
          />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosPersonalizados.formulario.LimiteDeHoras}:</label>
          <input value={this.state.hours_limit} name="hours_limit" className="form-control" onChange={this.handleChange.bind(this, 'hours_limit')} placeholder={this.locale.Designacoes.EditarDesignacao.tabRequisitosPersonalizados.formulario.placeholder.LimiteDeHoras} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosPersonalizados.formulario.DiasCorridos}:</label>
          <input value={this.state.days} name="days" className="form-control" onChange={this.handleChange.bind(this, 'days')} placeholder={this.locale.Designacoes.EditarDesignacao.tabRequisitosPersonalizados.formulario.placeholder.DiasCorridos} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-12">
        <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Designacoes.EditarDesignacao.tabRequisitosPersonalizados.formulario.botaoAdicionarRequisito}</button>
      </div>
    </div>
  </form>
  <hr/>
  {Object.keys(self.state.designation_requisitions).map(function(k) {
    return (
      <DesignationCustomRequisitionComponent handleAlert={self.props.handleAlert} RequestApi={self.refs.request_api} loadData={self.props.loadData} designation_id={self.state.designation_requisitions[k].designation_id} designation_requisition_id={self.state.designation_requisitions[k].id} designation_requisition={self.state.designation_requisitions[k]} certifications_list={self.props.certifications_list} deleteRequisiton={self.deleteRequisiton} />
    );
  })}
</div>
    );
  }
}

export default DesignationCustomRequisitionTab;



// WEBPACK FOOTER //
// ./src/Components/Designations/Elements/DesignationCustomRequisitionTab.js